import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {Observable, ReplaySubject} from "rxjs";

@Component({
  selector: 'app-video-dialog',
  templateUrl: './video-dialog.component.html',
  styleUrls: ['./video-dialog.component.scss']
})
export class VideoDialogComponent implements OnInit {
  public form: FormGroup;
  constructor(public dialogRef: MatDialogRef<VideoDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public fb: FormBuilder) {}

  ngOnInit(): void { 
    this.form = this.fb.group({
      id: null,
      title: null,
      descriptions: null,
      videoSrc: null,
      mobileSrc: null
    });
    if(!this.data.video){
        this.form.patchValue(this.data.video);
    }else{
        // this.getBase64ImageFromUrl(this.data.video.videoSrc).then(res => {
        //   console.log(res)
        //   this.data.video.videoSrc=res
          this.form.patchValue(this.data.video);
        // })
    }

  }

  async getBase64ImageFromUrl(imageUrl) {
    var res = await fetch(imageUrl);
    var blob = await res.blob();

    return new Promise((resolve, reject) => {
      var reader  = new FileReader();
      reader.addEventListener("load", function () {
        resolve(reader.result);
      }, false);

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    })
  }

  public onSubmit(){
    if(this.form.valid){
      this.dialogRef.close(this.form.value);
    }
  }

  convertFile(file : File){
    let format;
    var reader = new FileReader();
    reader.readAsDataURL(file);
    if(file.type.indexOf('image')> -1){
      format = 'image';
    } else if(file.type.indexOf('video')> -1){
      format = 'video';
    }
    reader.onload = (event) => {
      this.form.value.videoSrc = (<FileReader>event.target).result;
    }
  }

  fileUpload($event: Event) {
    // @ts-ignore
    this.convertFile($event.target.files[0]);
  }
}
